<template>
  <div class="grupous">
    <h1>Grupos de Usuario</h1>
    <div class="d-flex justify-content-end mb-3">
      <router-link to="/grupous/add" class="btn btn-primary">
        <i class="bi bi-plus-circle me-1"></i> Nuevo Grupo
      </router-link>
    </div>
    
    <div class="alert alert-info" v-if="loading">Cargando grupos...</div>
    <div class="alert alert-danger" v-if="error">{{ error }}</div>
    
    <div class="table-responsive" v-if="!loading && !error && grupous.length > 0">
      <table class="table table-striped table-hover">
        <thead class="table-dark">
          <tr>
            <th>Código</th>
            <th>Nombre</th>
            <th>Fecha Creación</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="grupo in grupous" :key="grupo.GrupouCode">
            <td>{{ grupo.GrupouCode }}</td>
            <td>{{ grupo.GrupouName }}</td>
            <td>{{ format(new Date(grupo.FechaCreacion), 'dd/MM/yyyy HH:mm') }}</td>
            <td>
              <div class="btn-group">
                <router-link :to="`/grupos/edit/${grupo.GrupouCode}`" class="btn btn-sm btn-warning me-1">
                  <i class="bi bi-pencil"></i> Editar
                </router-link>
                <button @click="confirmDelete(grupo.GrupouCode)" class="btn btn-sm btn-danger">
                  <i class="bi bi-trash"></i> Borrar
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    
    <div class="alert alert-warning" v-if="!loading && !error && grupous.length === 0">
      No hay grupos registrados. <router-link to="/grupous/add">Agregar un nuevo grupo</router-link>.
    </div>

    <div class="mt-4">
      <router-link to="/" class="btn btn-secondary">
        <i class="bi bi-arrow-left me-1"></i> Volver al Menú
      </router-link>
    </div>
  </div>
</template>

<script>
import { useAccessControl } from '@/composables/useAccessControl'
import GrupousViewController from './GrupousController.js';
import { format } from 'date-fns';

export default {
  name: 'GrupousView',
  setup() {
    const { requiresAuth, requiresMenuPermission } = useAccessControl({
      requiresAuth: true,
      requiresMenuPermission: true
    })

    return {
      requiresAuth,
      requiresMenuPermission
    }
  },
  data() {
    return {
      controller: new GrupousViewController()
    }
  },
  computed: {
    grupous() {
      return this.controller.getGrupous();
    },
    loading() {
      return this.controller.isLoading();
    },
    error() {
      return this.controller.getCurrentError();
    }
  },
  created() {
    this.controller.initialize();
  },
  methods: {
    fetchGrupous() {
      this.controller.loadGrupous();
    },
    async deleteGrupou(code) {
      if (confirm(`¿Está seguro que desea eliminar el grupo "${code}"?`)) {
        try {
          await this.controller.deleteGrupou(code);
          await this.controller.reloadGrupous();
          alert('Grupo eliminado correctamente.');
        } catch (error) {
          alert('No se pudo eliminar el grupo. Por favor, intente nuevamente.');
        }
      }
    },
    confirmDelete(code) {
      this.deleteGrupou(code);
    },
    format
  }
}
</script>
